import { Flex, Heading, Text, useToast } from '@chakra-ui/react'
import { AxiosError } from 'axios'
import {
  EditOrganizationUnit,
  OrganizationUnit,
  OrganizationUnitProperties,
} from 'BrokerTsLib/src/dtos'
import {
  useCreateOrganizationUnit,
  useGetAcquisitionNumbers,
  useGetOrganizationUnitById,
  useGetPossibleTypes,
} from 'BrokerTsLib/src/hooks/useOrganizationUnit'
import { useMemo, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { Container } from '@/components/Container'
import { Section } from '@/components/Section'
import { OrganizationEditForm } from '@/containers/organization/OrganizationEditForm'
import { PageContent } from '@/containers/PageContent'
import { OrganizationLink } from '@/containers/shared/OrganizationLink'

export const OrganizationCreateDependentPage = () => {
  const { organizationUnitId: organizationUnitIdParam } = useParams()
  const organizationUnitId = Number(organizationUnitIdParam)

  const { data: superiorOrganizationData } =
    useGetOrganizationUnitById(organizationUnitId)
  const superiorOrganization = superiorOrganizationData?.data

  const navigate = useNavigate()
  const toast = useToast()

  const [organization] = useState({
    superiorOrganizationUnitId: organizationUnitId,
  } as OrganizationUnit)
  const [properties] = useState({} as OrganizationUnitProperties)

  const { data: possibleTypesData } = useGetPossibleTypes(
    undefined,
    organizationUnitId,
  )
  const possibleTypes = useMemo(
    () => [...Array.from(new Set(possibleTypesData?.data ?? []))],
    [possibleTypesData],
  )

  const { data } = useGetAcquisitionNumbers(organizationUnitId)

  const { mutateAsync: create } = useCreateOrganizationUnit()

  const onSubmit = (values: EditOrganizationUnit) =>
    create(values)
      .then((response) => {
        navigate('/organization/' + response.data.id)

        return response
      })
      .catch((e: AxiosError) => {
        toast({
          title: 'Chyba při vytváření organizace',
          description: `${e.response?.status}: ${e.response?.statusText}`,
          status: 'error',
        })

        return e
      })

  return (
    <Section>
      <Container>
        <PageContent>
          <Heading>Vytvořit podřízenou organizaci</Heading>

          <Flex display={'flex'}>
            <Text>Nadřízená organizace:&nbsp;</Text>
            <OrganizationLink
              name={superiorOrganization?.name}
              id={superiorOrganization?.id}
            />
          </Flex>

          <OrganizationEditForm
            organization={organization}
            properties={properties}
            onSubmit={onSubmit}
            possibleTypes={possibleTypes}
            isCreate
          />
        </PageContent>
      </Container>
    </Section>
  )
}
